import React from "react";
import PropTypes from "prop-types";

const ChevronDownIcon = ({
  width,
  height,
  color,
  strokeWidth,
  className,
  ...props
}) => (
  <svg
    width={width || 16}
    height={height || 16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M4 6L8 10L12 6"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ChevronDownIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

ChevronDownIcon.defaultProps = {
  width: undefined,
  height: undefined,
  color: "currentColor",
  strokeWidth: 1.33333,
  className: "",
};

export default ChevronDownIcon;
